import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { shortFormProjects } from "@/data/portfolio";

const youtubeId = (url) =>
    url?.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/)?.[1];

const ShortEmbed = ({ project, index }) => {
    const id = youtubeId(project.url);

    return (
        <Reveal delay={index * 0.06}>
            <div
                data-testid={`shortform-card-${project.id}`}
                className="overflow-hidden rounded-3xl border border-white/10 bg-ink-3 shadow-[0_20px_60px_-25px_rgba(0,0,0,0.9)]"
            >
                {id ? (
                    <iframe
                        data-testid={`shortform-embed-${project.id}`}
                        src={`https://www.youtube.com/embed/${id}`}
                        title={project.title}
                        loading="lazy"
                        className="aspect-[9/16] w-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                ) : (
                    <img
                        src={project.thumbnail}
                        alt={project.title}
                        loading="lazy"
                        className="aspect-[9/16] w-full object-cover"
                    />
                )}
            </div>
        </Reveal>
    );
};

const ShortFormProjects = () => {
    const [first, second, third] = shortFormProjects;

    return (
    <section data-testid="shortform-section" className="relative py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index={3}
                eyebrow="Portfolio"
                title={
                    <>
                        Short Form{" "}
                        <em className="font-serifit text-[1.06em] font-medium italic text-[#f6e3d3]">
                            Videos
                        </em>
                    </>
                }
                subtitle="Fast-paced, engaging edits built for social media."
            />
            <div className="grid gap-6 sm:gap-8 md:grid-cols-2">
                <ShortEmbed project={first} index={0} />
                <ShortEmbed project={second} index={1} />
            </div>
            {third && (
                <div className="mx-auto mt-6 w-full sm:mt-8 md:max-w-[calc(50%-1rem)]">
                    <ShortEmbed project={third} index={2} />
                </div>
            )}
        </div>
    </section>
    );
};

export default ShortFormProjects;
